<template>
    <el-dialog ref="imagePreviewDialog" :title="title" :visible.sync="visibility" center width="50%" height="50%" custom-class="image-preview-dialog">
        <el-carousel
            ref="elCarousel"
            :initial-index="index"
            trigger="click"
            :autoplay="false"
            height="500px"
            :arrow="arrow"
            style="background: rgba(0, 0, 0, 0.9);">
            <el-carousel-item v-for="src in srcs" :key="src" style="display: flex; justify-content: center; align-items: center;">
                <el-image :src="src" fit="scale-down" style="width: 100%; height: 100%;"></el-image>
            </el-carousel-item>
        </el-carousel>
    </el-dialog>
</template>

<script>
    export default {
        name: "ImagePreview",
        data() {
            return {
                visibility: false,
                index: 0,
            };
        },
        props: {
            srcs: {
                type: Array,
                default: [],
            },
            title: {
                type: String,
                default: "预览",
            },
            // visible: Boolean,
            // index: {
            //     type: Number,
            //     default: 0,
            // }
        },
        mounted() {
            this.$refs.imagePreviewDialog.open = () =>
            {
                this.$refs.elCarousel.setActiveItem(this.index);
            };
        },
        methods: {
            open(index) {
                if (index>=0)
                    this.index=index;
                this.visibility = true;
            },
            close() {
                this.visibility = false;
            }
        },
        computed: {
            arrow() {
                return this.srcs.length>1 ? "hover" : "never";
            }
            // visibility: {
            //     set(v) {
            //         this.$emit("update:visible", v);
            //     },
            //     get() {
            //         return this.visible;
            //     }
            // },
        }
    }
</script>

<style>
    .image-preview-dialog.el-dialog--center.el-dialog .el-dialog__body {
        padding: 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/dialog/ImagePreview.vue